module.exports = __webpack_public_path__ + "img/interaction-first-response-time.98fdee53.png";